import React, {
    useContext
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { SgDateUtil, SgActiveTestsContext } from 'saga-modules';
import SphConstants from 'sg-sph-constants';
import CommonConstants from 'sg-common-constants';
import messages from './SgSPHRenewalSummaryInfo.messages';
import SgRenewalAddonSummary from '../sg-renewal-addon-summary';

function SgSPHRenewalSummaryInfo(props) {
    const {
        renewalDetails
    } = props;

    const translator = useContext(TranslatorContext);
    const { activeMvtTests } = useContext(SgActiveTestsContext);
    const buildingCover = renewalDetails.mainCoverages.find((cov) => cov.name === SphConstants.COVERAGES_NAMES.BUILDINGS);
    const contentsCover = renewalDetails.mainCoverages.find((cov) => cov.name === SphConstants.COVERAGES_NAMES.CONTENTS);

    const coverLevelName = (term) => {
        let coverName;
        if (renewalDetails.renewalUpgradeData.isPlusP1) {
            if (term.value === SphConstants.COVER_TERMS.HOME_INSURANCE) {
                coverName = CommonConstants.COVER_LEVEL_NAMES.PLUS;
            } else if (term.value === SphConstants.COVER_TERMS.ESSENTIAL) {
                coverName = CommonConstants.COVER_LEVEL_NAMES.SELECT;
            } else if (term.value === SphConstants.COVER_TERMS.ESSENTIAL_WITH_AD) {
                coverName = CommonConstants.COVER_LEVEL_NAMES.SELECT;
            } else {
                coverName = term.value;
            }
        } else {
            coverName = term.value;
        }
        return coverName;
    };

    const coverLevelNameWoc3143 = (cover) => {
        let coverName;
        if (renewalDetails.renewalUpgradeData.isPlusP1 && cover.terms.length > 1) {
            switch (cover.terms[0].value) {
                case SphConstants.COVER_TERMS.HOME_INSURANCE:
                    coverName = `${CommonConstants.COVER_LEVEL_NAMES.PLUS} (${cover.terms[1].value})`;
                    break;
                case SphConstants.COVER_TERMS.ESSENTIAL:
                case SphConstants.COVER_TERMS.ESSENTIAL_WITH_AD:
                    coverName = `${CommonConstants.COVER_LEVEL_NAMES.SELECT} (${cover.terms[1].value})`;
                    break;
                default:
                    coverName = `${cover.terms[0].value} (${cover.terms[1].value})`;
            }
        } else {
            coverName = cover.terms[0].value;
        }
        return coverName;
    };

    return (
        <>
            <div className="sgPolicyInfo">
                <div className="sgPolicyInfoName">{translator(messages.AddressLabel)}</div>
                <div id="renewalDescription" className="sgPolicyInfoValue">{renewalDetails.description}</div>
            </div>
            {activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143)
            && (
                <>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.BuildingsLabel)}</div>
                        <div className="sgPolicyInfoValue">
                            { buildingCover && buildingCover.terms && (
                                <div>{coverLevelNameWoc3143(buildingCover)}</div>
                            )}
                        </div>
                    </div>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.ContentsLabel)}</div>
                        <div className="sgPolicyInfoValue">
                            { contentsCover && contentsCover.terms && (
                                <div>{coverLevelNameWoc3143(contentsCover)}</div>
                            )}
                        </div>
                    </div>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.CoverYearLabel)}</div>
                        <div id="coverStart" className="sgPolicyInfoValue">
                            {translator(messages.CoverYearInfo, {
                                startDate: SgDateUtil.getDateWithFullMonthName(renewalDetails.periodStart),
                                endDate: SgDateUtil.getDateWithFullMonthName(renewalDetails.periodEnd)
                            })}
                        </div>
                    </div>
                </>
            )}
            {!activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143)
            && (
                <>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.BuildingsLabel)}</div>
                        <div className="sgPolicyInfoValue">
                            { buildingCover && buildingCover.terms && buildingCover.terms.map((term, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <div key={`buildings_term_${index}_container`} id={`buildings_term_${index}`}>{coverLevelName(term)}</div>
                            ))}
                        </div>
                    </div>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.ContentsLabel)}</div>
                        <div className="sgPolicyInfoValue">
                            {contentsCover && contentsCover.terms && contentsCover.terms.map((term, index) => {
                                const contentsTermContainerKey = `contents_term_${index}_container`;
                                return (
                                    <div key={contentsTermContainerKey} id={`contents_term_${index}`}>{coverLevelName(term)}</div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.CSDLabel)}</div>
                        <div id="coverStart" className="sgPolicyInfoValue">{SgDateUtil.getDateWithFullMonthName(renewalDetails.periodStart)}</div>
                    </div>
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.RenewalDateLabel)}</div>
                        <div id="renewalDate" className="sgPolicyInfoValue">{SgDateUtil.getDateWithFullMonthName(renewalDetails.periodEnd)}</div>
                    </div>
                </>
            )}
            <SgRenewalAddonSummary renewalDetails={renewalDetails} />
        </>
    );
}

export default SgSPHRenewalSummaryInfo;
